import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment';

class ModalBanner extends Component {
  state = {
    now: moment(),
    isMobile: window.innerWidth < 768,
  };

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({ now: moment() });
    }, 1000);
    this.handleResize = () => this.setState({ isMobile: window.innerWidth < 768 });
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const { isMobile } = this.state;
    const { popupCmsContent,
      popupExtraContentCtaLabel,
      popupExtraContentCtaUrl,
      popupExtraContentText,
      popupExtraContentTitle,
      popupCountdownEndDate,
      popupShowCountdown,
      popupCmsContentMobile,
    } = this.props;

    const targetDate = moment(popupCountdownEndDate);
    const diffMs = targetDate.diff(this.state.now);
    const duration = moment.duration(Math.max(diffMs, 0));

    const formatNumber = n => String(n).padStart(2, '0');


    return (
      <div className="modal fade" id="modalBanner" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="form">

          <div className="modal-content">
            <div className="modal-body" style={{
              background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%)'
            }} /*style="background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);"*/>

              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <ion-icon name="close-outline" role="img" className="md hydrated"></ion-icon>
              </button>


              <span dangerouslySetInnerHTML={{__html: isMobile && popupCmsContentMobile ? popupCmsContentMobile : popupCmsContent}}/>

              {popupShowCountdown === '1' && duration.isValid() ?
              <div className="countdown-timer mb-4">
                <div className="d-flex justify-content-center">
                  <div className="countdown-item">
                    <div className="countdown-number">{formatNumber(Math.floor(duration.asDays()))}</div>
                    <div className="countdown-label">días</div>
                  </div>
                  <div className="countdown-item">
                    <div className="countdown-number">{formatNumber(duration.hours())}</div>
                    <div className="countdown-label">horas</div>
                  </div>
                  <div className="countdown-item">
                    <div className="countdown-number">{formatNumber(duration.minutes())}</div>
                    <div className="countdown-label">minutos</div>
                  </div>
                  <div className="countdown-item">
                    <div className="countdown-number">{formatNumber(duration.seconds())}</div>
                    <div className="countdown-label">segundos</div>
                  </div>
                </div>
              </div>
                :
                <></>
              }


              {popupExtraContentTitle && popupExtraContentText ?
                <div className="modal-banner-content text-center mb-4">
                  <h3 className="modal-banner-title mb-3 mt-2">{popupExtraContentTitle}</h3>
                  <p className="modal-banner-description mb-0">{popupExtraContentText}</p>
                </div>
                :
                <></>
              }


              {popupExtraContentCtaUrl && popupExtraContentCtaLabel ?<div className="text-center">
                <a href={popupExtraContentCtaUrl}
                   className="btn btn-primary btn-lg btn-block">{popupExtraContentCtaLabel}</a>
              </div> : <></>}

            </div>
          </div>

        </div>
      </div>

    )

      /*
    return (
      <div className="modal fade" id="modalBanner" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-xl modal-dialog-centered" role="form">


          <div className="modal-content">
            <div className="modal-body p-0">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <ion-icon name="close-outline"></ion-icon>
              </button>
              <span dangerouslySetInnerHTML={{__html: popupCmsContent}}/>
            </div>
          </div>



        </div>
      </div>
    )
*/
  }
}

const mapStateToProps = ({ AppReducer }) => {
  const { popupCmsContent,     popupExtraContentCtaLabel,
    popupExtraContentCtaUrl,
    popupExtraContentText,
    popupExtraContentTitle,
    popupCountdownEndDate,
    popupShowCountdown,
    popupCmsContentMobile,
  } = AppReducer;

  return {
    popupCmsContent,
    popupExtraContentCtaLabel,
    popupExtraContentCtaUrl,
    popupExtraContentText,
    popupExtraContentTitle,
    popupCountdownEndDate,
    popupShowCountdown,
    popupCmsContentMobile,
  }
};

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ModalBanner)
